module.exports = __webpack_public_path__ + "img/detail-solution-1-6.b8aaa28f.png";